// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2837":"fe3c5c1f","5324":"ffe7bb42","6061":"2239b61e"}[chunkId] + ".js";
};